<template>
  <div class="quality-wrap">
    <div class="guide">
      <a href="yingtan/dist/html/navigation.html">首页 >></a>
      <router-link :to="{name: 'home'}">耕地利用大数据 >></router-link>
      <router-link :to="{name: 'quality'}">耕地质量</router-link>
    </div>
    <div class="conclusion-list">
      <div class="conclusion-item">
        <span>{{conclusion.zong}}</span>
        <span>（万公顷）</span>
        <p>耕地总面积</p>
        <i class="iconfont icon-zong"></i>
      </div>
      <div class="conclusion-item">
        <span>{{conclusion.youdeng}}</span>
        <span>（万公顷）</span>
        <p>优等耕地面积</p>
        <i class="iconfont icon-youdeng"></i>
      </div>
      <div class="conclusion-item">
        <span>{{conclusion.dideng}}</span>
        <span>（万公顷）</span>
        <p>低等耕地面积</p>
        <i class="iconfont icon-dideng"></i>
      </div>
      <div class="conclusion-item">
        <span>{{conclusion.baozhang}}</span>
        <span>（万公顷）</span>
        <p>保障耕地面积</p>
        <i class="iconfont icon-baozhang"></i>
      </div>
      <div class="conclusion-item">
        <span>{{conclusion.shiji}}</span>
        <span>（万公顷）</span>
        <p>实际耕地面积</p>
        <i class="iconfont icon-shiji"></i>
      </div>
    </div>
    <div class="navs">
      <router-link class="nav-list" tag="a" :to="{name: 'general'}">耕地质量概况分析</router-link>
      <router-link class="nav-list" tag="a" :to="{name: 'farmland'}">高标准农田分析</router-link>
      <router-link class="nav-list" tag="a" :to="{name: 'soil'}">耕地土壤质量分析</router-link>
      <router-link class="nav-list" tag="a" :to="{name: 'environment'}">耕地环境质量分析</router-link>
    </div>
    <div class="content-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script type="text/javascript">

  export default {
    name: 'quality',
    data() {
      return{
        conclusion: {
          zong: 1124,
          youdeng: 547,
          dideng: 132,
          baozhang: 623,
          shiji: 457
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/lib-variable";
  @import "../../assets/css/lib-mixin";
  .quality-wrap {
    width: 100%;
    height: 100%;
    .guide {
      a {
        color: #bffffb;
        @include animate();
        &:hover {
          color: #fff;
        }
      }
    }
    .conclusion-list {
      width: 100%;
      height: 110px;
      margin: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .conclusion-item {
        width: calc((100% - 48px) / 5);
        height: 100%;
        background-color: #017c80;
        box-sizing: border-box;
        padding: 20px 20px 0;
        position: relative;
        span:nth-child(1) {
          font-size: 24px;
          font-weight: bold;
        }
        span:nth-child(2) {
          font-size: $fz-sr;
        }
        &:nth-child(1) {
          color: #5bdaff;
          border: 1px rgba(0,213,251,.7) solid;
          background-color: rgba(0,193,255,.35);
          p {
            color: #aad9e7;
          }
        }
        &:nth-child(2) {
          color: #35ece6;
          border: 1px rgba(53,236,230,.7) solid;
          background-color: rgba(49,210,225,.3);
          p {
            color: #7cc8c6;
          }
        }
        &:nth-child(3) {
          color: #eeed62;
          border: 1px rgba(214,255,91,.7) solid;
          background-color: rgba(255,240,0,.25);
          p {
            color: #d5d79b;
          }
        }
        &:nth-child(4) {
          color: #f6c038;
          border: 1px rgba(233,177,43,.83) solid;
          background-color: rgba(236,165,29,.3);
          p {
            color: #d1b87b;
          }
        }
        &:nth-child(5) {
          color: #ffa94b;
          border: 1px rgba(247,144,23,.71) solid;
          background-color: rgba(235,120,18,.25);
          p {
            color: #cea170;
          }
        }
        .iconfont {
          font-size: 72px;
          opacity: .6;
          position: absolute;
          right: 10px;
          bottom: -23px;
        }
      }
    }
    .navs {
      width: 100%;
      margin-bottom: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .nav-list {
        color: #a1ffec;
        font-size: $fz-sm;
        font-weight: bold;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        box-sizing: border-box;
        padding: 0 26px;
        margin-right: 20px;
        /*background: radial-gradient(50% 85%, #39b6ac 10%, rgba(255,255,255,0));*/
        border: 1px transparent solid;
        border-radius: 15px;
        @include animate();
        &:hover, &.active, &:focus {
          color: #fff;
          background: radial-gradient(50% 85%, #39b6ac 10%, rgba(255,255,255,0));
          border: 1px #2ac7c8 solid;
          border-radius: 15px;
        }
      }
    }
    /*.content-wrap {
      width: 100%;
      height: calc(100% - 213px);
      background-color: #fff;
    }*/
  }

</style>



// WEBPACK FOOTER //
// src/pages/quality/quality.vue